const FitnessBuddyGallery = () => {
    return (
      <div className=" fb-gallery-container">
    </div>
    )
    
  };
  export default FitnessBuddyGallery;
  